import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { IDetailsListWrapper } from './types';
import { useNavigate } from 'react-router-dom';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import CardLayoutDetails from './CardLayout';
import { Typography } from '@mui/material';

const DetailsListWrapper = (props: IDetailsListWrapper) => {
  const { title, detailsList = [] } = props;
  const navigate = useNavigate();

  return (
    <>
      <CardLayoutDetails title={title}>
        <List component='nav'>
          {detailsList.map((item: any) => {
            return (
              <ListItem key={item.name.label}>
                <ListItemButton onClick={() => navigate(`${item.name.url}`)}>
                  <ListItemText primary={
                    <Typography sx={{ fontWeight: 'bolder',
                      whiteSpace: 'nowrap',
                      maxWidth: '440px',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis'}}>
                      {item.name.label}
                    </Typography>}
                  secondary={item.value.join(' ')} />
                  <ListItemIcon>
                    <ArrowForwardIosIcon />
                  </ListItemIcon>
                </ListItemButton>
              </ListItem>
            );
          })}
        </List>
      </CardLayoutDetails>

    </>
  );
};

export default DetailsListWrapper;